import CommonState from './CommonState'

export const PROPERTY_CUSTOMER = new CommonState(1, '客户', 'Customer')
export const PROPERTY_BOOKING_AGENT = new CommonState(2, '订舱/换单代理', 'Booking Agent')
export const PROPERTY_OVERSEA_AGENT = new CommonState(3, '目的港代理', 'Oversea Agent')
export const PROPERTY_DESIGNATION_AGENT = new CommonState(4, '指定代理', 'Designation Agent')
export const PROPERTY_LOCAL_AGENT = new CommonState(5, '本地代理', 'Local Agent')
export const PROPERTY_SETTLEMENT_AGENT = new CommonState(6, '结算代理', 'Settlement Agent')
export const PROPERTY_SEA_COMPANY = new CommonState(7, '船公司', 'Sea Company')
export const PROPERTY_AIR_COMPANY = new CommonState(8, '航空公司', 'Air Company')
export const PROPERTY_CUSTOMER_BROKER = new CommonState(9, '报关公司', 'Customer Broker')
export const PROPERTY_WAREHOUSE = new CommonState(10, '仓库', 'Warehouse')
export const PROPERTY_TRUCK_COMPANY = new CommonState(11, '车队', 'Truck Company')
export const PROPERTY_SHIPPER = new CommonState(12, '发货人', 'Shipper')
export const PROPERTY_CONSIGNEE = new CommonState(13, '收货人', 'Consignee')
export const PROPERTY_NOTIFY = new CommonState(14, '通知人', 'Notify')
export const PROPERTY_OTHER = new CommonState(15, '其它', 'Other')

/**
 * 合作伙伴属性列表
 */
export const PROPERTIES = [
  PROPERTY_CUSTOMER,
  PROPERTY_SEA_COMPANY,
  PROPERTY_AIR_COMPANY,
  PROPERTY_BOOKING_AGENT,
  PROPERTY_DESIGNATION_AGENT,
  PROPERTY_CUSTOMER_BROKER,
  PROPERTY_WAREHOUSE,
  PROPERTY_TRUCK_COMPANY,
  PROPERTY_OVERSEA_AGENT,
  PROPERTY_LOCAL_AGENT,
  PROPERTY_SETTLEMENT_AGENT,
  PROPERTY_SHIPPER,
  PROPERTY_CONSIGNEE,
  PROPERTY_NOTIFY,
  PROPERTY_OTHER
]

export const EMAIL_SEND_OBJ_CUSTOMER = new CommonState(0, '客户邮箱', 'Customer Mailbox')
export const EMAIL_SEND_OBJ_INVOICE = new CommonState(1, '开票申请人', 'invoice Applicant')
export const EMAIL_SEND_OBJ_INPUT_BY = new CommonState(2, '发票创建人', 'Input By')

/**
 * 邮箱发送对象
 * @type {CommonState[]}
 */
export const EMAIL_SEND_OBJS = [EMAIL_SEND_OBJ_CUSTOMER, EMAIL_SEND_OBJ_INVOICE, EMAIL_SEND_OBJ_INPUT_BY]
